import { Collection as BaseCollection } from 'backbone';

/**
 * Base collection class
 *
 * See [Backbone Documentation][1]
 *
 * [1]: http://backbonejs.org/#Collection
 *
 * @class Ofcs.Collection
 * @extends Backbone.Collection
 */
export default class Collection extends BaseCollection {
    remove(modelsArg, options, ...args) {
        super.remove(modelsArg, options, ...args);

        let models = modelsArg;
        if (!Array.isArray(models)) models = [models];
        this.trigger('removeComplete', models, this, options);
    }
}
